// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import 'swiper/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false

Axios.defaults.baseURL = '/XLH/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted () {
   // You'll need this for renderAfterDocumentEvent.
    //document.dispatchEvent(new Event('render-active'))
    document.dispatchEvent(new Event('custom-render-trigger'))
    
   },
})



// WEBPACK FOOTER //
// ./src/main.js